import { propertyDetailSearchFields } from '../../../../common/forms/generalRealEstate/fields'
import { denormalizeDecimalFields } from '../../../../utils/general'
import { Criteria, filterEmptyDetailSearchValues } from '../utils'

// Transforms flat form values (propertyWeb/attribute, price format) to match the API's criteria shape.
// TODO: check with backend whether the criteria contract could accept propertyWeb/attribute as flat fields, to avoid this transforming.
export const transformPropertyDetailSearchCriteria = (values: Criteria): Criteria => {
    const {
        [propertyDetailSearchFields.WEB]: webId,
        [propertyDetailSearchFields.ATTRIBUTE]: attribute,
        ...rest
    } = filterEmptyDetailSearchValues(values)

    return {
        ...rest,
        ...(webId
            ? { [propertyDetailSearchFields.WEB]: { id: webId, ...(attribute ? { [propertyDetailSearchFields.ATTRIBUTE]: attribute } : {}) } }
            : {}),
        ...denormalizeDecimalFields(rest, [propertyDetailSearchFields.PRICE_FROM, propertyDetailSearchFields.PRICE_TO]),
    }
}
